const commonPermissionGroupDefinitions = [
    {
        key: 'lead_assigned_worker',
        title: {
            ru: 'Работа с лидами (свои)',
            en: 'Assigned Lead Work',
        },
        description: {
            ru: 'Базовый набор для менеджера: просмотр и редактирование назначенных лидов, комментарии и история.',
            en: 'Basic manager access for assigned leads, comments, and activity history.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.assigned',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.leads_management_comments.assigned',
            'lead.list_lead_logs',
        ],
    },
    {
        key: 'lead_desk_worker',
        title: {
            ru: 'Работа с лидами отдела',
            en: 'Desk Lead Work',
        },
        description: {
            ru: 'Для сотрудников отдела: доступ к лидам отдела с базовым редактированием и комментариями.',
            en: 'Desk-level lead access with basic editing and comment permissions.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.desk',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.leads_management_comments.all',
            'lead.list_lead_logs',
        ],
    },
    {
        key: 'support_comment_reviewer',
        title: {
            ru: 'Поддержка и комментарии',
            en: 'Support and Comments',
        },
        description: {
            ru: 'Для поддержки: просмотр лидов, работа с комментариями и история без редактирования самих лидов.',
            en: 'Support-focused access for viewing leads, handling comments, and checking activity history without editing leads.',
        },
        permissions: [
            'lead.list_leads',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.list_lead_logs',
        ],
    },
    {
        key: 'lead_full_worker',
        title: {
            ru: 'Полная работа с лидами',
            en: 'Full Lead Work',
        },
        description: {
            ru: 'Расширенный набор для старших сотрудников: все лиды, редактирование, комментарии и история.',
            en: 'Extended lead workflow with all-lead access, editing, comments, and logs.',
        },
        permissions: [
            'lead.list_leads',
            'lead.create_leads',
            'lead.update_leads',
            'lead.leads_management_common.all',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.delete_lead_comments',
            'lead.leads_management_comments.all',
            'lead.list_lead_logs',
        ],
    },
    {
        key: 'sales_operator',
        title: {
            ru: 'Продажи и сделки',
            en: 'Sales and Orders',
        },
        description: {
            ru: 'Работа с назначенными лидами, сделками и платежами без доступа к управлению админами.',
            en: 'Assigned lead workflow plus orders and payment operations without admin management.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.assigned',
            'lead.list_orders',
            'lead.create_orders',
            'lead.update_orders',
            'lead.close_orders',
            'lead.list_payments',
            'lead.create_payments',
            'lead.update_payments',
            'lead.work_with_bonus',
            'lead.work_with_deposit',
            'lead.work_with_withdraw',
        ],
    },
    {
        key: 'sales_manager',
        title: {
            ru: 'Менеджер продаж',
            en: 'Sales Manager',
        },
        description: {
            ru: 'Работа с лидами и возможность назначать лиды другим менеджерам за счет доступа к списку админов.',
            en: 'Lead workflow plus access to the admin list so leads can be reassigned to other managers.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.assigned',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.leads_management_comments.assigned',
            'lead.list_lead_logs',
            'user.list_admin_accounts',
        ],
    },
    {
        key: 'retention_manager',
        title: {
            ru: 'Менеджер удержания',
            en: 'Retention Manager',
        },
        description: {
            ru: 'Только работа с лидами без доступа к списку админов и без управления сотрудниками.',
            en: 'Lead-only workflow without access to admin lists or employee management.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.assigned',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.leads_management_comments.assigned',
            'lead.list_lead_logs',
        ],
    },
    {
        key: 'desk_head',
        title: {
            ru: 'Руководитель отдела',
            en: 'Desk Head',
        },
        description: {
            ru: 'Руководитель отдела: видит лиды отдела, может работать с ними и просматривать всех админов.',
            en: 'Desk supervisor with desk-wide lead access and visibility into all admin accounts.',
        },
        permissions: [
            'lead.list_leads',
            'lead.create_leads',
            'lead.update_leads',
            'lead.delete_leads',
            'lead.leads_management_common.desk',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.delete_lead_comments',
            'lead.leads_management_comments.all',
            'lead.list_lead_logs',
            'user.list_admin_accounts',
            'user.admin_accounts_management.desk',
        ],
    },
    {
        key: 'head_of_managers',
        title: {
            ru: 'Руководитель менеджеров',
            en: 'Head of Managers',
        },
        description: {
            ru: 'Старший менеджер с полным доступом к лидам, комментариям и списку всех администраторов.',
            en: 'Senior manager with full lead visibility, comment access, and access to all admins.',
        },
        permissions: [
            'lead.list_leads',
            'lead.create_leads',
            'lead.update_leads',
            'lead.delete_leads',
            'lead.leads_management_common.all',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.delete_lead_comments',
            'lead.leads_management_comments.all',
            'lead.list_lead_logs',
            'user.list_admin_accounts',
            'user.admin_accounts_management.all',
        ],
    },
    {
        key: 'affiliate_sales_manager',
        title: {
            ru: 'Affiliate sales manager',
            en: 'Affiliate Sales Manager',
        },
        description: {
            ru: 'Работа с лидами и доступ к аффилиатам для связки трафика с продажами.',
            en: 'Lead workflow plus affiliate account visibility for affiliate-driven sales.',
        },
        permissions: [
            'lead.list_leads',
            'lead.update_leads',
            'lead.leads_management_common.assigned',
            'lead.list_lead_comments',
            'lead.create_lead_comments',
            'lead.leads_management_comments.assigned',
            'lead.list_lead_logs',
            'user.list_affiliator_accounts',
        ],
    },
];

export const COMMON_PERMISSIONS_TAB_KEY = 'commonPermissions';

export const getAvailableCommonPermissionGroups = (permissions = []) => {
    const availablePermissionNames = new Set(
        permissions
            .map((permission) => permission?.name)
            .filter(Boolean)
    );

    return commonPermissionGroupDefinitions
        .map((group) => {
            const matchedPermissions = group.permissions.filter((permissionName) =>
                availablePermissionNames.has(permissionName)
            );

            return {
                ...group,
                permissions: matchedPermissions,
            };
        })
        .filter((group) => group.permissions.length > 0);
};
